import { IService } from 'types/institutions';

export const formatData = (servicesData: IService[], page: number, perPage: number) => {
  return servicesData?.map((el, i) => ({
    ...el,
    sublimitName: el.subSubLimitName || el.subLimitName,
    number: (page - 1) * perPage + i + 1,
  }));
};
